import { ReactNode } from 'react';
import { Grid } from '@optimus-web/core';

export const PayoutSummaryGrid = ({ children }: { children: ReactNode }) => (
    <Grid gap="200" templateColumns="repeat(4, 1fr)" tabletMax={{ templateColumns: 'repeat(2, 1fr)' }}>
        {children}
    </Grid>
);
